import { Injectable } from '@angular/core';
import { BuildingApi } from './../api/building.api';
import { BuildingAdminDTO } from '../model/buildings/building-management.model';

@Injectable()
export class BuildingService {


    constructor(private buildingApi: BuildingApi) { }

    getPortalBuildings = () => this.buildingApi.getPortalBuildings();
    getBuildingsForAdmin = () => this.buildingApi.getBuildingsForAdmin();
    getAssignedBuildings = (userId: string) => this.buildingApi.getAssignedBuildings(userId);
    getBuildingDetails = (buildingId: number) => this.buildingApi.getBuildingDetails(buildingId);
    saveBuilding = (formValue: BuildingAdminDTO) => this.buildingApi.saveBuilding(formValue);
    deleteBuilding = (building: BuildingAdminDTO) => this.buildingApi.deleteBuilding(building);
    preCheckDeleteBuilding = (building: BuildingAdminDTO) => this.buildingApi.preCheckDeleteBuilding(building);
}
